import React, { useEffect, useRef, useState } from "react";
import { useSnackbar } from "notistack";
import { Modal, Box, Typography, Autocomplete, TextField } from "@mui/material";
import GridContainer from "../../../../../componentsv2/GridContainer";
import GridItem from "../../../../../componentsv2/GridItem";
import Button from "../../../../../componentsv2/Button";
import Paper from "../../../../../componentsv2/Paper";
import { api } from "../../../../../services/Api";
import getApiErrorMessage from "../../../../../utils/getApiErrorMessage";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "min(560px, 94vw)",
  maxHeight: "92vh",
  overflow: "auto",
};

export default function ModalCadastroEnfermeiro({ open, onClose, onSalvar }) {
  const { enqueueSnackbar } = useSnackbar();
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);
  const [candidatos, setCandidatos] = useState([]);
  const [salvando, setSalvando] = useState(false);
  const searchTimerRef = useRef(null);

  useEffect(() => {
    if (open) {
      setUsuarioSelecionado(null);
      setCandidatos([]);
    }
    return () => {
      if (searchTimerRef.current) {
        clearTimeout(searchTimerRef.current);
        searchTimerRef.current = null;
      }
    };
  }, [open]);

  async function buscarCandidatos(textoDigitado) {
    const termo = textoDigitado.trim();
    if (termo.length < 2) {
      setCandidatos([]);
      return;
    }
    try {
      const {
        data: { data },
      } = await api.get("/v2/agendaCare/enfermeiros/usuarios-disponiveis", {
        params: { q: termo.slice(0, 120) },
      });
      setCandidatos(Array.isArray(data) ? data : []);
    } catch (error) {
      enqueueSnackbar(getApiErrorMessage(error, "Erro na pesquisa."), {
        variant: "error",
      });
      setCandidatos([]);
    }
  }

  function handleUsuarioSearchInput(_, value, reason) {
    if (reason !== "input") {
      return;
    }
    if (searchTimerRef.current) {
      clearTimeout(searchTimerRef.current);
    }
    searchTimerRef.current = setTimeout(() => {
      buscarCandidatos(value);
    }, 350);
  }

  const handleSubmit = async () => {
    if (!usuarioSelecionado?.id) {
      enqueueSnackbar("Escolha um login na lista.", { variant: "warning" });
      return;
    }
    const usuarioIdNumerico = Number(usuarioSelecionado.id);
    if (!Number.isInteger(usuarioIdNumerico) || usuarioIdNumerico <= 0) {
      enqueueSnackbar("Identificador inválido. Escolha de novo na lista.", { variant: "warning" });
      return;
    }
    setSalvando(true);
    try {
      await onSalvar({ usuarioId: usuarioIdNumerico });
    } finally {
      setSalvando(false);
    }
  };

  const submitDisabled =
    salvando ||
    !usuarioSelecionado?.id ||
    !Number.isInteger(Number(usuarioSelecionado.id)) ||
    Number(usuarioSelecionado.id) <= 0;

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <Paper sx={{ p: 3 }}>
          <GridContainer spacing={2}>
            <GridItem xs={12}>
              <Typography variant="h6">Novo enfermeiro</Typography>
              <Typography variant="body2" sx={{ color: "#64748b", mt: 1 }}>
                Associa uma conta existente ao Agenda Care.
              </Typography>
            </GridItem>

            <GridItem xs={12}>
              <Autocomplete
                value={usuarioSelecionado}
                onChange={(_, value) => setUsuarioSelecionado(value)}
                options={candidatos}
                getOptionLabel={option => {
                  if (!option) {
                    return "";
                  }
                  const nomeParaExibir = option.nome?.trim() || "—";
                  return `${nomeParaExibir} · ${option.username}`;
                }}
                isOptionEqualToValue={(a, b) => a?.id === b?.id}
                filterOptions={opcoes => opcoes}
                onInputChange={handleUsuarioSearchInput}
                noOptionsText="Digite 2 ou mais caracteres."
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Login"
                    variant="standard"
                    required
                    placeholder="Nome ou login"
                    helperText="Logins ainda sem enfermeiro no Agenda Care."
                  />
                )}
              />
            </GridItem>

            <GridItem xs={12} style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
              <Button variant="outlined" color="blue" onClick={onClose} disabled={salvando}>
                Cancelar
              </Button>
              <Button variant="contained" color="blue" onClick={handleSubmit} disabled={submitDisabled}>
                Salvar
              </Button>
            </GridItem>
          </GridContainer>
        </Paper>
      </Box>
    </Modal>
  );
}
